import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MonoLabel } from './MonoLabel';

interface PageHeaderProps {
  title: string;
  eyebrow?: string;
  eyebrowTone?: 'mute' | 'acc';
  /** Lede under the h1. */
  lede?: string;
  /** Right-aligned action, bottom-aligned with the title block. */
  action?: ReactNode;
  className?: string;
}

/** Page top: mono eyebrow, 46px h1, optional lede and action. Starts 52px down. */
export function PageHeader({ title, eyebrow, eyebrowTone = 'mute', lede, action, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-7 pt-[52px]', className)}>
      <div>
        {eyebrow && (
          <MonoLabel tone={eyebrowTone} size="md" className="block">
            {eyebrow}
          </MonoLabel>
        )}
        <h1 className="mt-[14px] text-[46px] font-semibold leading-[1.04] tracking-[-0.03em]">{title}</h1>
        {lede && <p className="mt-3 max-w-[46ch] text-base leading-[1.5] text-mute">{lede}</p>}
      </div>
      {action}
    </div>
  );
}
